import { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplyScope } from '@spike/new-booking-model';
import {
    AppointmentEditOrigin,
    cancelAppointmentEditScopeThunk,
    confirmAppointmentEditScopeThunk,
    NewBookingsStatus,
    PendingAppointmentEdit
} from '@spike/new-bookings-action';
import { useApiClientWrapper } from 'hooks';
import { RootState } from 'store';
import RecurringEditScopeDialog from './RecurringEditScopeDialog';

export interface AppointmentEditScopeDialogContainerProps {
    origin: AppointmentEditOrigin;
    zIndex?: number;
    onConfirm?: (applyScope: ApplyScope) => void;
}

export const AppointmentEditScopeDialogContainer: FunctionComponent<AppointmentEditScopeDialogContainerProps> = ({
    origin,
    zIndex,
    onConfirm
}) => {
    const dispatch = useDispatch();
    const apiClientWrapper = useApiClientWrapper();

    const pendingEdit = useSelector<RootState, PendingAppointmentEdit | undefined>(
        state => state.newBookings.appointmentEditScope
    );
    const newBookingsStatus = useSelector<RootState, NewBookingsStatus>(state => state.newBookings.status);

    const open = pendingEdit !== undefined && pendingEdit.origin === origin;

    const confirmHandler = (applyScope: ApplyScope) => {
        onConfirm?.(applyScope);
        dispatch(confirmAppointmentEditScopeThunk(apiClientWrapper, applyScope));
    };

    const cancelHandler = () => {
        dispatch(cancelAppointmentEditScopeThunk());
    };

    return (
        <RecurringEditScopeDialog
            open={open}
            title={pendingEdit?.edit.type === 'cancel' ? 'Cancel Recurring Appointment' : 'Edit Recurring Appointment'}
            noun="appointment"
            futureScopeDescription={pendingEdit?.summary.message}
            isSaving={open && newBookingsStatus === NewBookingsStatus.UpdatingAppointment}
            zIndex={zIndex}
            onCancel={cancelHandler}
            onConfirm={confirmHandler}
        />
    );
};

export default AppointmentEditScopeDialogContainer;
